import { ComponentProps } from 'react'

import { Button } from '@/components/ui/button'
import { ChatActionWithValue } from '../../models/insuranceApplication'

export interface ChatButtonGroupProps {
  buttons: Array<{ label: string; value: string; href?: string; props?: ComponentProps<typeof Button> }>
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  readonly?: boolean
}

export function ChatButtonGroup({ buttons, handleSubmit, readonly }: ChatButtonGroupProps) {
  function onSubmit(label: string, value: string) {
    handleSubmit({
      content: {
        component: 'P',
        content: label,
      },
      value: value,
    })
  }

  return (
    // Right, where the customer's reply will land.
    <div className="flex flex-col items-end gap-2 self-end">
      {buttons.map((button) => (
        <Button
          key={button.value}
          variant="outlineThin"
          size="sm"
          {...button.props}
          onClick={
            readonly ? undefined : button.value ? () => onSubmit(button.label, button.value) : undefined
          }
          href={readonly ? undefined : button.href}
          disabled={readonly || button.props?.disabled}
        >
          {button.label}
        </Button>
      ))}
    </div>
  )
}
